module.exports = __webpack_public_path__ + "img/menu-warranty-document.529c47a6.svg";